import { sortBy } from 'lodash'
import moment from 'moment'
import uuid from 'uuid/v4'
import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { Activity, ActivityState, StoreState } from '@/interfaces'
import { updateVueObject } from '@/utils'
import firebase from '@/firebase'

let database: any
let primaryKey: string = 'id'

function initialState (): ActivityState {
  return {
    loaded: {}
  }
}

const actions: ActionTree<ActivityState, StoreState> = {
  initialize ({ commit }) {
    commit('setLoaded', [
      {
        id: uuid(),
        created: moment('2019-01-01').valueOf(),
        notes: 'I did some lifting today!'
      },
      {
        id: uuid(),
        created: moment('2019-01-02').valueOf(),
        notes: 'I did some lifting today!'
      },
      {
        id: uuid(),
        created: moment('2019-01-03').valueOf(),
        notes: 'I did some lifting today!'
      }
    ])
  },
  save ({ commit }, activity: Activity) {
    if (!activity.id) {
      activity.id = uuid()
    }

    if (!activity.created) {
      activity.created = moment().valueOf()
    }

    commit('setLoaded', activity)
  }
}

const getters: GetterTree<ActivityState, StoreState> = {
  recent (state) {
    return sortBy(state.loaded, 'created').reverse()
  }
}

const mutations: MutationTree<ActivityState> = {
  setLoaded (state, activities: Activity|Activity[]) {
    updateVueObject(state.loaded, activities, primaryKey)
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  getters,
  mutations
}
